export function validatePhone(value) {
    let phoneFormat = /(^(998)(\d{9}$))/;
    return phoneFormat.test(value)
}

export function empty(value) {
    return value === null || value === undefined || value.toString().length === 0
}

export function validateEmail(value) {
    let emailFormat = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return emailFormat.test(value);
}

export function validateUsername(value) {
    if (validateEmail(value) || validatePhone(value)) {
        return true
    } else {
        return false;
    }
}

export function validInn(value) {
    let innFormat = /(^(\d{9}$))/
    return innFormat.test(value);
}